import { TableCell, TableRow } from '@mui/material'
import React from 'react'
import { Link } from 'react-router-dom';
import PackQrGet from './actions/packQr/PackQrGet';

const PackItem = ({ pack }) => {
  return (
    <TableRow>
        <TableCell align='center'>
            {pack.id}
        </TableCell>
        <TableCell align='center'>
            {/* {pack.goodId} */}
            {
                pack.goodType ? pack.goodType.name : ''
            }
            {' '}
            {
                pack.good ? pack.good.name : ''
            }
        </TableCell>
        <TableCell align='center'>
            <Link
                to={`/production/packs/${pack.id}/boxes`}
            >
                {
                    // pack.packSeries
                    pack.seriesText
                }
            </Link>
            {/* {pack.packSeries} */}
        </TableCell>
        {/* <TableCell align='center'>
            товари
            </TableCell> */}
        <TableCell align='center'>
            {pack.count}
        </TableCell>
        <TableCell align='center'>
            {pack.keyCrmOrderId}
        </TableCell>
        {/* <TableCell align='center'>
            {pack.number}
        </TableCell> */}
        {/* <TableCell align='center'>
            {pack.year}
        </TableCell> */}
        <TableCell align='center'>
            {/* {pack.customerType} */}
            {pack.customerTypeName}
        </TableCell>
        <TableCell align='center'>
            {/* {pack.type} */}
            {pack.typeName}
        </TableCell>
        <TableCell align='center'>
            {pack.password}
        </TableCell>
        <TableCell align="center" className='myTable__actions'>
            <PackQrGet 
                packId={pack.id}
            />
            {/* <PackQrGet 
                packId={pack.id}
                type='barcode'
            /> */}
            {/* <PackBarCodeGet 
                packId={pack.id}
            /> */}
        </TableCell>
    </TableRow>
  )
}

export default PackItem